export const TRIAGE_DATA = {
  TEMPERATURE: "temperature",
  OXYGEN_SATURATION: "oxygenSaturation",
  HEART_RATE: "heathRate",
  RESPIRATION_RATE: "respirationRate",
  BLOOD_PRESSURE: "bloodPressure",
  BLOOD_PRESSURE2: "bloodPressure2",
  CARE: "care",
  CARE_VALUE: "careValue",
  TRIAGE_TAKEN_BY: "triageTakenBy",
  TRIAGE_TAKEN_BY_ID: "triageTakenId",
  TRIAGE_TAKEN_LOCATION: "triageTakenLocation",
};

export const ORDER_QUANTITY = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
];

export const ORDER_QUANTITY_UNIT = [
  {
    label: "Tablet",
    value: "Tablet",
  },
  {
    label: "Capsule",
    value: "Capsule",
  },
  {
    label: "Milliliters (mL)",
    value: "Milliliters (mL)",
  },
  {
    label: "Milligrams (mg)",
    value: "Milligrams (mg)",
  },
  {
    label: "Drops (gtts)",
    value: "Drops (gtts)",
  },
  {
    label: "Ampoule",
    value: "Ampoule",
  },
  {
    label: "Pack",
    value: "Pack",
  },
  {
    label: "Puff",
    value: "Puff",
  },
  {
    label: "International Units (IU)",
    value: "International Units (IU)",
  },
  {
    label: "Nebule",
    value: "Nebule",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const FREQUENCY_OPTIONS = [
  { label: "STAT: One time, immediately", value: "stat" },
  { label: "ONCE: One time", value: "once" },
  { label: "DAILY: Once daily", value: "daily" },
  { label: "BID: Twice daily", value: "bid" },
  { label: "TID: Three times daily", value: "tid" },
  { label: "QID: Four times daily", value: "qid" },
  { label: "PRN: As needed", value: "prn" },
  { label: "QAM: Every morning", value: "qam" },
  { label: "QPM: Every evening", value: "qpm" },
  { label: "QHS: Every night at bedtime", value: "qhs" },
  { label: "Q2H: Every 2 hours", value: "q2h" },
  { label: "Q4H: Every 4 hours", value: "q4h" },
  { label: "Q6H: Every 6 hours", value: "q6h" },
  { label: "Q8H: Every 8 hours", value: "q8h" },
  { label: "Q12H: Every 12 hours", value: "q12h" },
  { label: "AC: Before meals", value: "ac" },
  { label: "PC: After meals", value: "pc" },
];


export const RX_ORDER_DETAILS = {
  ORDER_QUANTITY: "qty",
  MEDICATION_NAME: "medicationName",
  UNIT: "unit",
  NOTES: "notes",
  START_DATE: "startDate",
  END_DATE: "endDate",
  MEDICATION_NAME_TITLE: "medicationTitle",
  FREQUENCY: "frequency",
};

export const EKG_ORDER_DETAILS = {
  NOTES: "notes",
};

export const X_RAY_ORDER_DETAILS = {
  X_RAY_INFO: "xRayInfo",
  NOTES: "notes",
};

export const CUSTOM_lABEL_STYLE = {
  fontSize: "16px",
  fontWeight: 500,
  color: "#393939",
  marginBottom: "10px",
};

export const SEVERITY_PROPERTIES = [
  { label: "High", value: "high" },
  { label: "Moderate", value: "moderate" },
  { label: "Normal", value: "normal" },
];

export const COMMON_FONT16_500 = {
  fontSize: "16px",
  fontWeight: 500,
};
export const COMMON_COLOR1D1D1D = {
  color: "#1D1D1D",
};
export const COMMON_COLOR565656 = {
  color: "#565656",
};

export const COMMON_MARGIN_BOTTOM_8PX = {
  marginBottom: "8px",
};
